
<template>
  <div class="app outside-page flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-block">
                <h1>Resetear la contrase&ntilde;a</h1>
                <p class="text-muted">A continuaci&oacute;n escriba la nueva contrase&ntilde;a</p>
                <vue-form :state="formstate" v-model="formstate" @submit.prevent="onSubmit">
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.email)">
                    <label>Correo Electr&oacute;nico</label>
                    <input type="email" name="email" class="form-control" required v-model.lazy="model.email">

                    <field-messages name="email" show="$touched || $submitted" class="form-control-feedback">
                      <div>Exito!</div>
                      <div slot="required">El correo es obligatorio</div>
                      <div slot="email">El correo es invalido</div>
                    </field-messages>
                  </validate>

                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.password)">
                <label>Contrase&ntilde;a</label>
                <input type="password" password-strength name="password" class="form-control" required
                       v-model.lazy="model.password">

                <field-messages auto-label name="password" show="$touched || $submitted" class="form-control-feedback">
                  <div>Exito!</div>
                  <div slot="required">La contrase&ntilde;a es Requerida</div>
                  <div slot="password-strength">
                    Debe cumplir con lo siguiente:
                    <ul>
                      <li>Debe tener al menos 8 Caracteres</li>
                      <li>Debe contener al menos 1 mayuscula, 1 miniscula, numeros y 1 caracter especial </li>
                    </ul>
                  </div>
                </field-messages>

              </validate>

              <validate auto-label class="form-group required-field"
                        :class="fieldClassName(formstate.password_confirmation)">
                <label>Confirmar Contrase&ntilde;a</label>
                <input type="password" :matches="model.password" name="password_confirmation" class="form-control" required
                       v-model.lazy="model.password_confirmation">

                <field-messages auto-label name="password_confirmation" show="$touched || $submitted"
                                class="form-control-feedback">
                  <div>Exito!</div>
                  <div slot="required">Escriba la Confirmaci&oacute;n de la clave</div>
                  <div slot="matches">Las Contrase&ntilde;as no coinciden</div>
                </field-messages>

              </validate>
              <div class="alert alert-success" v-if="success">{{message}}</div>
              <div v-if="error" class="alert alert-danger">
                <p v-if="message"> {{message}}</p>
                <p v-for="err in errors">{{err[0]}}</p>
              </div>
              <div class="py-2 text-center">
                <button class="btn btn-primary" type="submit">Cambiar</button>
              </div>
            </vue-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'reset',
    data () {
      return {
        formstate: {},
        model: {
          email: '',
          password: '',
          password_confirmation: '',
          token: ''
        },
        message: '',
        processing: false,
        error: false,
        success: false,
        errors: []
      }
    },
    methods: {
      fieldClassName (field) {
        // for bootstrap classes
        if (!field) {
          return ''
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
          return 'has-success'
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
          return 'has-danger'
        }
      },
      onSubmit () {
        this.model.token = this.$route.params.token
        if (this.formstate.$valid) {
          this.ChangePasswd()
        }
      },
      ChangePasswd () {
        this.processing = true
        this.error = ''
        this.$http.post('password/reset', this.model)
          .then(
            (response) => {
              this.success = true
              this.message = 'Se cambio la Contraseña correctamente'
              this.processing = false
              this.error = false
              this.formstate._reset()
              setTimeout(() => {
                this.$router.push('/login')
              }, 2000)
            },
            (res) => {
              if (typeof res.body === 'object') {
                this.errors = res.body.errors
                this.error = true
                this.message = res.body.message
                this.success = false
              } else {
                this.error = false
              }
              this.processing = false
            }
          )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/auth/Reset.vue